"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var client_1 = require("@apollo/client");
var lodash_1 = require("lodash");
var __1 = __importDefault(require(".."));
var AsyncTable = function (_a) {
    var _b, _c;
    var query = _a.query, queryResultFormatter = _a.queryResultFormatter, queryVariablesFormatter = _a.queryVariablesFormatter, queryVariables = _a.queryVariables, _d = _a.tableProps, tableProps = _d === void 0 ? {} : _d, filterValues = _a.filterValues, dataSourceFilter = _a.dataSourceFilter;
    var _e = client_1.useQuery(query, {
        variables: queryVariablesFormatter
            ? queryVariablesFormatter(queryVariables, filterValues)
            : queryVariables,
    }), loading = _e.loading, data = _e.data, refetch = _e.refetch;
    var _f = react_1.useState({
        defaultPageSize: 25,
    }), pagination = _f[0], setPagination = _f[1];
    var dataSource = react_1.useMemo(function () {
        var ds = queryResultFormatter ? queryResultFormatter(data).data : data;
        return dataSourceFilter ? dataSourceFilter(ds) : ds;
    }, [data, queryResultFormatter, dataSourceFilter]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var onChange = react_1.useCallback(lodash_1.debounce(function (
    // eslint-disable-next-line @typescript-eslint/no-shadow
    pagination, filters, sorter, extra) {
        var _a, _b;
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        ((_a = tableProps.antdTableProps) === null || _a === void 0 ? void 0 : _a.onChange) &&
            ((_b = tableProps.antdTableProps) === null || _b === void 0 ? void 0 : _b.onChange(pagination, filters, sorter, extra));
        var variables = queryVariablesFormatter
            ? queryVariablesFormatter(queryVariables, filterValues, pagination, filters, sorter, extra)
            : queryVariables;
        setPagination(pagination);
        refetch(variables);
    }, 500), [queryVariablesFormatter, filterValues, queryVariables]);
    return (react_1.default.createElement(__1.default, { antdTableProps: __assign(__assign({}, tableProps.antdTableProps), { pagination: __assign(__assign({}, (((_b = tableProps === null || tableProps === void 0 ? void 0 : tableProps.antdTableProps) === null || _b === void 0 ? void 0 : _b.pagination)
                ? (_c = tableProps.antdTableProps) === null || _c === void 0 ? void 0 : _c.pagination
                : {})), pagination), dataSource: dataSource,
            loading: loading,
            onChange: onChange }) }));
};
exports.default = AsyncTable;
